import { useAuthUser } from "react-auth-kit";
import { PermissionsEnum } from "../utils/interfaces/permissions.enum";

export const usePermissionGuard = (role:PermissionsEnum) => {
    const auth = useAuthUser();
    const permissions = auth()?.role.permissions;
    const show = permissions.find((item:PermissionsEnum) => item === role) ? true : false;
    return show
}